export default __webpack_public_path__ + "static/media/block.c2caf20f.svg";